module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projects"
  }, [_c('box-helper', {
    attrs: {
      "headline": "Opgaver",
      "identifier": "projects"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container section"
  }, [_c('title-block', {
    staticClass: "mb-xl",
    attrs: {
      "headline": "<b>Opgaver</b>",
      "position": "center"
    }
  }, [_c('p', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("\n                Ét samlet overblik over dine opgaver\n            ")])]), _vm._v(" "), (_vm.$route.name === 'ProjectsOperations') ? _c('view-toggle', {
    attrs: {
      "operationsName": "Drift",
      "operationsLink": "ProjectsOperations",
      "learningName": "Udvikling / læring",
      "learningLink": "ProjectsLearning"
    }
  }) : _vm._e(), _vm._v(" "), _c('router-view')], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6020b3ac", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6020b3ac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/projects/projects.vue
// module id = 848
// module chunks = 0